import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-field _base-search-size" }
const _hoisted_2 = { class: "p-input-icon-right" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_4 = { class: "grid _relative" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 16h2v2h-2z",
      style: {"fill":"#dd3333","fill-opacity":"1"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.516 10h-3l.484 5h2z",
      style: {"fill":"#dd3333","fill-opacity":"1"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.017 5.974l7.519 13.026h-15.04l7.521-13.026m0-2.474c-.544 0-1.088.357-1.5 1.071l-7.985 13.831c-.825 1.429-.15 2.598 1.5 2.598h15.968c1.65 0 2.325-1.169 1.5-2.599l-7.983-13.829c-.413-.715-.956-1.072-1.5-1.072z",
      style: {"fill":"#dd3333","fill-opacity":"1"}
    })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Empty = _resolveComponent("Empty")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_NoImg = _resolveComponent("NoImg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, null, {
      left: _withCtx(() => [
        _createElementVNode("label", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_InputText, {
              type: "search",
              modelValue: _ctx.search,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              placeholder: _ctx.$t('vehicles_page.search')
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_Icon, {
              name: "zoom",
              className: "p-field-icon"
            })
          ])
        ])
      ]),
      right: _withCtx(() => [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.state.premoderationFilter,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.premoderationFilter) = $event)),
          options: _ctx.premoderationFilterOptions,
          optionLabel: "label",
          onChange: _ctx.refresh,
          optionValue: "value",
          class: "mb-4 mt-5"
        }, null, 8, ["modelValue", "options", "onChange"]),
        _hoisted_3,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.state.selectedCompany,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.selectedCompany) = $event)),
          options: _ctx.companies,
          optionLabel: "title",
          onChange: _ctx.refresh,
          optionValue: "id",
          filter: true,
          filterPlaceholder: "Find company",
          placeholder: "Select company",
          class: "mb-4 mt-5"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _: 1
    }),
    (!_ctx.state.isLoading && (!_ctx.state.data || !_ctx.state.data.length))
      ? (_openBlock(), _createBlock(_component_Empty, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.state.isLoading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            isOverlay: _ctx.state.data && _ctx.state.data.length
          }, null, 8, ["isOverlay"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.data, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "col-12 md:col-6 lg:col-4"
        }, [
          _createVNode(_component_router_link, {
            class: _normalizeClass(_ctx.$style.card),
            to: { name: 'VehicleModeration', params: { id: item.id } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.$style.imgBox, "flex align-items-center justify-content-center"])
              }, [
                (item.photo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: `${item.photo.url}`,
                      alt: "",
                      class: _normalizeClass([_ctx.$style.img, "_img-base"])
                    }, null, 10, _hoisted_5))
                  : (_openBlock(), _createBlock(_component_NoImg, { key: 1 }))
              ], 2),
              (item.vehicle_name)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(_ctx.$style.name)
                  }, _toDisplayString(item.vehicle_name), 3))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: _normalizeClass(_ctx.$style.name)
                  }, _toDisplayString(item.brand) + " " + _toDisplayString(item.model), 3)),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.$style.vin)
              }, _toDisplayString(item.vin), 3),
              (item.moderated)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 2,
                    class: _normalizeClass(_ctx.$style.unmoderated)
                  }, _toDisplayString(_ctx.$t('vehicles_page.not_moderated')), 3))
                : _createCommentVNode("", true),
              (!item.moderated)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 3,
                    class: _normalizeClass(_ctx.$style.moderated)
                  }, _toDisplayString(_ctx.$t('vehicles_page.moderated')), 3))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.$style.footer, "flex align-items-center justify-content-between"])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([[_ctx.$style.slots, item.photos_count === item.angles_count && _ctx.$style.full], "_label py-1 px-3"])
                }, _toDisplayString(item.photos_count || 0) + "/" + _toDisplayString(item.angles_count), 3),
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.$style.date)
                }, _toDisplayString(_ctx.dateformat(item.created_at * 1000, 'dd.mm.yyyy')), 3),
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.$style.company)
                }, _toDisplayString(item.company.title), 3)
              ], 2),
              (item.defect_state === 'defected')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: _normalizeClass(_ctx.$style.defected)
                  }, _hoisted_7, 2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["class", "to"])
        ]))
      }), 128))
    ]),
    _createVNode(_component_Paginator, {
      currentPage: _ctx.state.meta.current_page || _ctx.$route.query.page || 1,
      total: _ctx.state.meta.total,
      lastPage: _ctx.state.meta.last_page,
      perPage: _ctx.state.meta.per_page,
      count: _ctx.state.meta.to
    }, null, 8, ["currentPage", "total", "lastPage", "perPage", "count"])
  ], 64))
}